import {createSlice, PayloadAction, Slice} from '@reduxjs/toolkit';

export interface DeleteDialogState {
  open: boolean;
  onConfirm: (input: string) => void;
}

const initialState: DeleteDialogState = {
  open: false,
  onConfirm: () => {},
};

const deleteDialogSlice: Slice<DeleteDialogState> = createSlice({
  name: 'deleteDialog',
  initialState,
  reducers: {
    open: (state, action: PayloadAction<(input: string) => void>) => {
      state.open = true;
      state.onConfirm = action.payload;
    },
    close: (state) => {
      state.open = false;
    },
  },
});

export default deleteDialogSlice;
